import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"





export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string): string {
  if (!date) return "N/A";
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(date));
}

export function getStatusColor(status: string) {
  switch (status) {
    case "active": return "bg-green-100 text-green-800"
    case "draft": return "bg-yellow-100 text-yellow-800"
    case "archived": return "bg-red-100 text-red-800"
    default: return "bg-gray-100 text-gray-800"
  }
}
export function getImagePreview(image: File | string | null) {
  if (image instanceof File) {
    return URL.createObjectURL(image);
  }
  if (typeof image === "string") {
    return image; // already a URL
  }
  return undefined;
}


// utils/handleAxiosError.ts

export function handleAxiosError(error: any, auth: AuthContextInfo): never {
  console.error('API Error:', error);

  if (error.response) {
    const status = error.response.status;
    const message =
      error.response.data?.message ||
      `API error: ${status} ${error.response.statusText}`;

    // Optional: you can add specific handling for status codes
    if (status === 401) {
      auth?.logout();
      throw new Error('Session expired. Please login again.');
    }

    throw new Error(message);
  } else if (error.request) {
    throw new Error('No response received from server. Please check your internet connection.');
  } else {
    throw new Error(error.message || 'Unexpected error occurred.');
  }
}

export function getCurrency() {
  return [
    {
      name: 'Indian Rupees',
      symbol: 'INR'
    },
    {
      name: 'US Dollar',
      symbol: 'USD'
    },
    {
      name: 'Euro',
      symbol: 'EUR'
    },
    {
      name: 'Australian Dollar',
      symbol: 'AUD'
    },
    {
      name: 'Emirati Dirham',
      symbol: 'AED'
    },
    {
      name: 'British Pound',
      symbol: 'GBP'
    },
    {
      name: 'Singapore Dollar',
      symbol: 'SGD'
    },
    {
      name: 'Canadian  Dollar',
      symbol: 'CAD'
    },
    {
      name: 'Saudi Riyals',
      symbol: 'SAR'
    },
  ];
}
